import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../api/analytics-api';
import type { AnalyticsRange } from './types';

export const analyticsKeys = {
  all: ['analytics'] as const,
  dashboard: (range: AnalyticsRange) => [...analyticsKeys.all, 'dashboard', range] as const,
};

export function useDashboardQuery(range: AnalyticsRange) {
  return useQuery({
    queryKey: analyticsKeys.dashboard(range),
    queryFn: () => analyticsApi.getDashboard(range),
    staleTime: 60_000,
  });
}
